function injectStyle (ssrContext) {
  require("!!../node_modules/.pnpm/extract-text-webpack-plugin@3.0.2_webpack@3.12.0/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"sourceMap\":true}!../node_modules/.pnpm/vue-loader@13.7.2_babel-core@6.26.3_css-loader@0.28.11_ejs@2.5.7_handlebars@4.0.11_lodash@4.1_rbp4ogaxn23qxl5fl3e5a3zjvi/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-0a17b03d\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/.pnpm/vue-loader@13.7.2_babel-core@6.26.3_css-loader@0.28.11_ejs@2.5.7_handlebars@4.0.11_lodash@4.1_rbp4ogaxn23qxl5fl3e5a3zjvi/node_modules/vue-loader/lib/selector?type=styles&index=0!./App.vue")
}
var normalizeComponent = require("!../node_modules/.pnpm/vue-loader@13.7.2_babel-core@6.26.3_css-loader@0.28.11_ejs@2.5.7_handlebars@4.0.11_lodash@4.1_rbp4ogaxn23qxl5fl3e5a3zjvi/node_modules/vue-loader/lib/component-normalizer")
/* script */
var __vue_script__ = null
/* template */
import __vue_template__ from "!!../node_modules/.pnpm/vue-loader@13.7.2_babel-core@6.26.3_css-loader@0.28.11_ejs@2.5.7_handlebars@4.0.11_lodash@4.1_rbp4ogaxn23qxl5fl3e5a3zjvi/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0a17b03d\",\"hasScoped\":false,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../node_modules/.pnpm/vue-loader@13.7.2_babel-core@6.26.3_css-loader@0.28.11_ejs@2.5.7_handlebars@4.0.11_lodash@4.1_rbp4ogaxn23qxl5fl3e5a3zjvi/node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/App.vue
// module id = null
// module chunks = 